export default __webpack_public_path__ + "static/tt-d764853d2341115f6a5cea4b044664ff.svg";